import {Model} from './model';
import {Group} from './group'

export class Employee implements Model {
  id: number;
  person_id: number;
  created_at: Date;
  updated_at: Date;
  groups: Array<Group>;

  constructor(data?) {
    if (data != null) {
      this.fill(data);
    }
  }

  public fill(data) {
    this.id         = data['id'];
    this.person_id  = data['person_id'];
    this.created_at = data['created_at'];
    this.updated_at = data['updated_at'];
    this.groups     = data['groups'];
  }

  public serialize() {
    return this;
  }


}
